import { Provider } from '@angular/core';
import { IndexedDbProvider } from './provider';

export const idbProviders: Provider[] = [IndexedDbProvider];
